import Vue from 'vue'
import Vuex from 'vuex'

import AuthModule from './AuthModule'
import AddActionsModule from './ActionsModule'
import PageInfoModule from './PageInfoModule'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    route: null
  },
  getters: {},
  mutations: {
    SET_ROUTE(state, route) {
      state.route = route;
    }
  },
  actions: {},
  modules: {
    AuthModule,
    PageInfoModule,
    AddActionsModule,
  }
})
